// src/components/UI/CompanyDetailsForm.js
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "../common/Modal";
import Input from "../common/Input";
import Button from "../common/Button";
import AddressModal from "./AddressModal";
import { XIcon } from "@heroicons/react/solid"; // Import the icon
import {
  addCompanyDetailsThunk,
  updateCompanyDetailsThunk,
} from "../../store/thunks/companyDetailsThunks";
import { set } from "lodash";

const fromMock = {
  companyName: "Shree Ratn",
  website: "",
  taxId: "123",
  registrationNumber: "",
  socialMediaLinks: {
    linkedin: "",
    twitter: "",
    facebook: "",
    instagram: "",
  },
  contactPerson: {
    name: "Prem MiteshJethwa",
    email: "prem@mail.com",
    phone: "9004252561",
  },
  address: {
    label: "",
    line1: "Flat no 104, Plot 56,, Seaview Building, Malwani Mhada",
    line2: "",
    city: "Mumbai",
    state: "Maharashtra",
    pinCode: "400095",
  },
};

const CompanyDetailsForm = ({ isOpen, onClose, initialData }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(
    initialData || {
      companyName: "",
      website: "",
      taxId: "",
      registrationNumber: "",
      logo: null,
      brandColor: "",

      socialMediaLinks: {
        linkedin: "",
        twitter: "",
        facebook: "",
        instagram: "",
      },
      contactPerson: {
        name: "",
        email: "",
        phone: "",
      },
      address: null,
    }
  );

  const [addressModalOpen, setAddressModalOpen] = useState(false);

  const handleAddressChange = (addressData) => {
    setFormData({ ...formData, address: addressData });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, logo: file });
  };

  const handleRemoveLogo = () => {
    setFormData({ ...formData, logo: null });
  };

  const handleNestedChange = (e, field) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [field]: { ...formData[field], [name]: value },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();

    // Append simple fields
    formDataToSend.append("companyName", formData.companyName);
    formDataToSend.append("website", formData.website);
    formDataToSend.append("taxId", formData.taxId);
    formDataToSend.append("registrationNumber", formData.registrationNumber);
    formDataToSend.append("brandColor", formData.brandColor);

    // Append the logo file
    if (formData.logo) {
      console.log("formData.logo", formData.logo);
      formDataToSend.append("logo", formData.logo);
    }

    // Append nested objects as JSON strings
    formDataToSend.append(
      "socialMediaLinks",
      JSON.stringify(formData.socialMediaLinks)
    );
    formDataToSend.append(
      "contactPerson",
      JSON.stringify(formData.contactPerson)
    );
    formDataToSend.append("address", JSON.stringify(formData.address));

    console.log("formDataToSend", formDataToSend);
    const action = formData._id
      ? updateCompanyDetailsThunk(formDataToSend)
      : addCompanyDetailsThunk(formDataToSend);

    dispatch(action)
      .then(() => {
        onClose();
      })
      .catch((error) => {
        console.error("Error saving company details:", error);
      });
  };

  // useEffect(() => {
  //   setFormData(fromMock);
  // },[]);

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      title="Company Details"
      isFullScreen
    >
      <form onSubmit={handleSubmit} className="">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Company Name"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            placeholder="Enter Company Name"
            required
          />
          <Input
            label="Website"
            name="website"
            value={formData.website}
            onChange={handleChange}
            placeholder="Enter Website URL"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Tax ID (GSTIN)"
            name="taxId"
            value={formData.taxId}
            onChange={handleChange}
            placeholder="Enter Tax ID"
          />
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Brand Color
            </label>
            <div className="flex items-stretch space-x-2">
              <input
                type="color"
                name="brandColor"
                value={formData.brandColor || "#ffffff"}
                onChange={handleChange}
                className="w-12 h-12 cursor-pointer"
              />
              <Input
                type="text"
                name="brandColor"
                value={formData.brandColor}
                onChange={handleChange}
                className="w-24"
                placeholder="#ffffff"
              />
            </div>
          </div>

          <div className="mb-6 md:flex">
            <div>
              <label className="block text-sm font-medium text-gray-700 ">
                {formData.logoUrl ? "Update Logo" : "Add Logo"}
              </label>

              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border file:border-gray-300 file:text-sm file:font-medium file:bg-gray-50 hover:file:bg-gray-100"
              />
            </div>
            {formData.logo && (
              <div className="relative mt-2">
                <img
                  src={URL.createObjectURL(formData.logo)}
                  alt="Logo Preview"
                  className="h-16 w-16 object-cover rounded-md border"
                />
                <XIcon
                  className="absolute bg-white rounded-full -top-2 -right-2 h-6 w-6 text-red-500 cursor-pointer"
                  onClick={handleRemoveLogo}
                />
              </div>
            )}

            {formData.logoUrl && (
              <div
                className={
                  formData.logo
                    ? "relative mt-2 ml-8 opacity-40"
                    : "relative mt-2 ml-8"
                }
              >
                <img
                  src={formData.logoUrl}
                  alt="Logo Preview"
                  className="h-16 w-16 object-cover rounded-md border"
                />
              </div>
            )}
          </div>
        </div>

        <div className="border-t mb-6">
          <h3 className="text-lg font-medium my-4">Company Address</h3>
          {formData.address ? (
            <div className="p-4 border rounded-md bg-gray-50">
              <p className="text-sm">
                <strong>Address Line 1:</strong>{" "}
                {formData.address.line1 || "N/A"}
              </p>
              <p className="text-sm">
                <strong>Address Line 2:</strong>{" "}
                {formData.address.line2 || "N/A"}
              </p>
              <p className="text-sm">
                <strong>City:</strong> {formData.address.city || "N/A"}
              </p>
              <p className="text-sm">
                <strong>State:</strong> {formData.address.state || "N/A"}
              </p>
              <p className="text-sm">
                <strong>Pin Code:</strong> {formData.address.pinCode || "N/A"}
              </p>
            </div>
          ) : (
            <p className="text-sm text-gray-500">No address added yet.</p>
          )}
          <Button
            variant="primary"
            className="mt-4"
            onClick={() => setAddressModalOpen(true)}
          >
            {formData.address ? "Edit Address" : "Add Address"}
          </Button>
        </div>

        <div className="border-t">
          <h3 className="text-lg font-medium my-4">Contact Person</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Name"
              name="name"
              value={formData.contactPerson.name}
              onChange={(e) => handleNestedChange(e, "contactPerson")}
              placeholder="Enter Contact Person Name"
            />
            <Input
              label="Email"
              name="email"
              type="email"
              value={formData.contactPerson.email}
              onChange={(e) => handleNestedChange(e, "contactPerson")}
              placeholder="Enter Contact Person Email"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Phone"
              name="phone"
              value={formData.contactPerson.phone}
              onChange={(e) => handleNestedChange(e, "contactPerson")}
              placeholder="Enter Contact Person Phone"
            />
          </div>
        </div>

        <div className="border-t">
          <h3 className="text-lg font-medium my-4">Social Media Links</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="LinkedIn"
              name="linkedin"
              value={formData.socialMediaLinks.linkedin}
              onChange={(e) => handleNestedChange(e, "socialMediaLinks")}
              placeholder="Enter LinkedIn URL"
            />
            <Input
              label="Twitter"
              name="twitter"
              value={formData.socialMediaLinks.twitter}
              onChange={(e) => handleNestedChange(e, "socialMediaLinks")}
              placeholder="Enter Twitter URL"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Facebook"
              name="facebook"
              value={formData.socialMediaLinks.facebook}
              onChange={(e) => handleNestedChange(e, "socialMediaLinks")}
              placeholder="Enter Facebook URL"
            />
            <Input
              label="Instagram"
              name="instagram"
              value={formData.socialMediaLinks.instagram}
              onChange={(e) => handleNestedChange(e, "socialMediaLinks")}
              placeholder="Enter Instagram URL"
            />
          </div>
          <div className="mt-6 flex justify-end space-x-2">
            <Button variant="primary" type="submit">
              Save
            </Button>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </form>

      {addressModalOpen && (
        <AddressModal
          isOpen={addressModalOpen}
          onClose={() => setAddressModalOpen(false)}
          onSave={handleAddressChange}
          initialData={formData.address}
        />
      )}
    </Modal>
  );
};

export default CompanyDetailsForm;
